import styled from "styled-components";

export const BuyMinerContainer = styled.div`
  padding-inline: 15px;
`;

export const BuyCard = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-block: 30px;
`;

export const BuyButton = styled.button`
  margin-inline-start: auto;
  height: 40px;
  width: 30%;
`;

export const MachineBuyValueText = styled.div`
  color: ${({ theme }) => theme.colors.link.text};
`;
